// src/features/marketResearch/components/PrintFooter.tsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export const PrintFooter: React.FC = () => {
  const theme = useTheme();
  return (
    <Box component="footer" sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 32,
      borderTop: `1px solid ${theme.palette.divider}`,
      px: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '@media print': { display: 'flex' },
      '@media screen': { display: 'none' },
    }}>
      <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
        Confidential
      </Typography>
      <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
        Page <span className="pageNumber" />
      </Typography>
    </Box>
  );
};
